import * as React from 'react'
import Magnifier from './magnifier'
import Modal from './../shared/modal'
import Spinner from './../shared/spinner'
import MediaElement from './mediaElement'
import {Button, TYPES} from './../shared/button'
import './../../styles/video/videoPlayer.css'


class VideoPlayer extends React.Component {
  constructor() {
    super()

    this.state = {
        screenshotToMagnify: null,
        screenshotForMagnifier: null,
        magnifiedAndCroppedScreenshot: null,
        inZoomMode: false,
        magnifiedAndCroppedModalActive: false,
        playbackRate: 1,
        displayAddNoteButton: true,
        currentVideoTime: 0,
        createNoteImage: false,
        videoIsPlaying: false,
        videoIsLoaded: false,
        displayPassengerMiddle: false
    }
  }

  componentDidMount() {
    this.addEventListeners()
  }

  componentDidUpdate() {
    this.removeEventListeners()
    this.addEventListeners()
  }

  componentWillUnmount() {
    this.removeEventListeners()
  }

  addEventListeners = () => {
    const video = document.getElementById('real-video_html5')
    video.crossOrigin = 'anonymous'
    video.addEventListener('canplay', this.createScreenshot)
    video.addEventListener('pause', this.createScreenshot)
    video.addEventListener('loadeddata', this.displayVideo)
    video.addEventListener('play', this.togglePlayStatus)
  }

  removeEventListeners = () => {
    const video = document.getElementById('real-video_html5')
    video.removeEventListener('canplay', this.createScreenshot)
    video.removeEventListener('pause', this.createScreenshot)
    video.removeEventListener('loadeddata', this.displayVideo)
    video.removeEventListener('play', this.togglePlayStatus)
  }

  createScreenshot = (event) => {
    if(event.type === 'pause') {
      this.togglePlayStatus()
    }
    const screenshotToMagnify = this.getDataURLFromVideo(event.target, 0)
    const screenshotForMagnifier = this.getDataURLFromVideo(event.target, 150)
    this.setState({currentVideoTime: event.target.currentTime, screenshotToMagnify: screenshotToMagnify, screenshotForMagnifier: screenshotForMagnifier})
    if(this.state.createNoteImage) {
      this.makeNoteFromImages(this.state.screenshotToMagnify, null)
    }
  }

  getDataURLFromVideo = (video, bufferWidth) => {
    const canvasForFullImage = document.createElement('canvas')
    const hiddenCtx= canvasForFullImage.getContext('2d')
    canvasForFullImage.height = video.videoHeight + (2 * bufferWidth)
    canvasForFullImage.width = video.videoWidth + (2 * bufferWidth)
    hiddenCtx.fillStyle = '#FFFFFF'
    hiddenCtx.fillRect(0, 0, video.videoWidth + (2 * bufferWidth), video.videoHeight + (2 * bufferWidth))
    hiddenCtx.drawImage(video, bufferWidth, bufferWidth, video.videoWidth, video.videoHeight)
    let dataURL = canvasForFullImage.toDataURL('image/jpeg', 1.0)
    canvasForFullImage.remove()
    return dataURL
}

  makeNoteFromImages = (fullImage, croppedImage) => {
    this.props.history.push(
      {
        pathname: `/recordings/${this.props.recording_id}/makenote`,
        state: { screenshot: fullImage, zoomScreenshot: croppedImage }
      }
    )
  }

  toggleZoomMode = () => {
    if(this.state.inZoomMode) {
      this.setState({inZoomMode: false, displayAddNoteButton: true})
      document.getElementById('video-inner-container').style.display = null
    } else {
      const video = document.getElementById('real-video_html5')
      video.pause()
      this.setState({inZoomMode: true})
    }
  }

  getZoomScreenshot = (magnifierWidth) => {
    const zoomCanvas = document.createElement('canvas')
    const zoomCtx= zoomCanvas.getContext('2d')
    var zoomImage = new Image()
    zoomImage.src = this.state.screenshotForMagnifier
    const zoomPercentX = parseFloat(document.getElementsByClassName('magnifying-glass')[0].style['backgroundPositionX'])
    const zoomPercentY = parseFloat(document.getElementsByClassName('magnifying-glass')[0].style['backgroundPositionY'])
    zoomCanvas.height = magnifierWidth
    zoomCanvas.width = magnifierWidth
    const topLeftCornerX = (zoomPercentX / 100 * zoomImage.width) - (zoomPercentX / 100) * (magnifierWidth)
    const topLeftCornerY = (zoomPercentY / 100 * zoomImage.height) - (zoomPercentY / 100) * (magnifierWidth)
    zoomCtx.fillRect(0, 0, zoomImage.width, zoomImage.height)
    zoomCtx.drawImage(zoomImage, topLeftCornerX, topLeftCornerY, magnifierWidth, magnifierWidth, 0, 0, magnifierWidth, magnifierWidth)
    const dataURL = zoomCanvas.toDataURL('image/jpeg', 1.0)
    this.setState(
      {magnifiedAndCroppedScreenshot: dataURL},
      () => this.toggleModal()
    )
  }

  displayZoomView = () => {
      let videoContainer = document.getElementById('video-container')
      document.getElementById('video-inner-container').style.display = 'none'
      const magnifierWidth = 0.5 * videoContainer.offsetWidth
      let videoPosition = {left: videoContainer.offsetLeft, top: videoContainer.offsetTop, width: videoContainer.offsetWidth, height: videoContainer.offsetHeight}
      return (
        <div onClick={() => this.getZoomScreenshot(magnifierWidth)} className='zoom'>
          <Magnifier width='100%' src={this.state.screenshotToMagnify} zoomImgSrc={this.state.screenshotForMagnifier} mgShape='square' mgHeight={magnifierWidth} mgWidth={magnifierWidth} videoPosition={videoPosition} />
        </div>
      )
  }

  toggleModal = () => {
    this.setState({ magnifiedAndCroppedModalActive: !this.state.magnifiedAndCroppedModalActive });
  }

  changePlaybackRate = (playbackRate) => {
    this.setState({playbackRate: playbackRate})
    const video =  document.getElementById('real-video_html5')
    video.playbackRate = playbackRate;
  }

  displayVideo = () => {
    this.setState({videoIsReady: true})
  }

  getNoteImage = () => {
    if(this.state.videoIsPlaying) {
      const video = document.getElementById('real-video_html5')
      this.setState({createNoteImage: true})
      video.pause()
    } else {
      this.makeNoteFromImages(this.state.screenshotToMagnify, null)
    }
  }

  togglePlayStatus = () => {
    this.setState({videoIsPlaying: !this.state.videoIsPlaying})
  }

  displayPassengerMiddle = () => {
    const video = document.getElementById('real-video_html5')
    if(this.state.displayPassengerMiddle) {
      video.src = this.props.videoURL
    } else {
      video.src = this.props.passenger_middle
    }
    this.setState({displayPassengerMiddle: !this.state.displayPassengerMiddle})
  }

  render () {
    const sources = [{src: this.props.videoURL, type: 'video/mp4'}],
          config = {},
          tracks = {}
    return (
      <div>
      {!this.state.videoIsReady &&
        <div id='loading-video'>
          <Spinner id='loading-video' size='100px'/>
        </div>
      }
      <div className={!this.state.videoIsReady ? 'hidden' : 'video-player-controller'}>
          <div className='video-player-controls'>
            <div className='video-playback'>
                <p>Playback Speed:</p>
                <div className='video-playback-button'>
                  {!this.props.needs_verification &&
                    <div>
                      <Button
                        text='1/4 X'
                        type="videoSpeed"
                        selected={this.state.playbackRate === .25}
                        id ='quarter-button'
                        onClick={() => {this.changePlaybackRate(.25)}}
                      />
                      <Button
                        text='1/2 X'
                        type="videoSpeed"
                        selected={this.state.playbackRate === .5}
                        id ='half-button'
                        onClick={() => {this.changePlaybackRate(.5)}}
                      />
                      <Button
                        text='1 X'
                        type="videoSpeed"
                        selected={this.state.playbackRate === 1}
                        id ='full-button'
                        onClick={() => {this.changePlaybackRate(1)}}
                      />
                    </div>
                  }
                  {this.props.needs_verification &&
                    <div>
                      <Button
                        text='1/2 X'
                        type="videoSpeed"
                        selected={this.state.playbackRate === .5}
                        id ='full-button'
                        onClick={() => {this.changePlaybackRate(.5)}}
                      />
                      <Button
                        text='1 X'
                        type="videoSpeed"
                        selected={this.state.playbackRate === 1}
                        id ='full-button'
                        onClick={() => {this.changePlaybackRate(1)}}
                      />
                      <Button
                        text='5 X'
                        type="videoSpeed"
                        selected={this.state.playbackRate === 5}
                        id ='half-button'
                        onClick={() => {this.changePlaybackRate(5)}}
                      />
                      <Button
                        text='10 X'
                        type="videoSpeed"
                        selected={this.state.playbackRate === 10}
                        id ='half-button'
                        onClick={() => {this.changePlaybackRate(10)}}
                      />
                    </div>
                  }
                </div>
            </div>
            <div className='video-note'>
              <div className='video-note-button'>
                <Button
                  text='Zoom'
                  type="videoControl"
                  selected={this.state.inZoomMode}
                  onClick={() => {this.toggleZoomMode()}}
                />
              </div>
              {this.props.needs_verification &&
                <div className='video-note-button'>
                  <Button
                    text='Passenger Middle'
                    type="videoControl"
                    selected={this.state.displayPassengerMiddle}
                    onClick={() => this.displayPassengerMiddle()}
                  />
                </div>
              }
              {this.state.displayAddNoteButton &&
                <div className='video-note-button'>
                {!this.props.needs_verification &&
                  <Button
                    text='Add Note'
                    type='addNote'
                    onClick={() => this.getNoteImage()}
                    buttonType={TYPES.SUBMIT}
                  />
                }
                </div>
              }
            </div>
          </div>
        <div className='video-player'>
          <div id='video-container'>
              <div id='video-inner-container'>
                <MediaElement
                  id='real-video'
                  currentTime={this.state.currentVideoTime}
                  mediaType='video'
                  preload='auto'
                  controls
                  width='100%'
                  height='100%'
                  sources={JSON.stringify(sources)}
                  options={JSON.stringify(config)}
                  tracks={JSON.stringify(tracks)}
                  videoUrl={this.props.videoURL}
                />
              </div>
            {this.state.inZoomMode &&
              <div id='screenshot-container'>
                {this.displayZoomView()}
              </div>
            }
          </div>
        </div>
        {this.state.magnifiedAndCroppedModalActive &&
          <Modal onCloseRequest={() => this.toggleModal()}>
            <div className='video-zoom-check'>
              <img src={this.state.magnifiedAndCroppedScreenshot} id='zoom-screenshot' alt=''/>
              <div className='video-zoom-buttons'>
                {!this.props.needs_verification &&
                  <Button
                    text='Add Note'
                    type='saveNote'
                    onClick={() => {this.makeNoteFromImages(this.state.screenshotToMagnify, this.state.magnifiedAndCroppedScreenshot)}}
                    buttonType={TYPES.SUBMIT}
                  />
                }
              </div>
            </div>
          </Modal>
        }
      </div>
      </div>
    )
  }
}


export default VideoPlayer



// WEBPACK FOOTER //
// ./src/components/video/videoPlayer.js